import React from "react";
import Pages from "@client.enums/pages";
import Tabs from "@client.components/Tabs/Tabs";

const SettingTabs = () => {
  const data = [
    {
      to: Pages.UsersManagement,
      title: "components.Settings.SettingTabs.usersManagement",
    },
    {
      to: Pages.InsightsSettings,
      title: "components.Settings.SettingTabs.insightsSettings",
    },
  ];
  return <Tabs data={data} />;
};

export default SettingTabs;
